<ng-template #dropdown let-items>
  <div class="dropdown-menu">
    <div
      *ngFor="let item of items"
      class="menu-item"
      [class.label]="!!item.backgroundColor"
      (click)="onInvoke(item.onClick)"
      (contextmenu)="onInvoke(item.onRightClick)"
    >
      <span [innerHTML]="item.text" [style.background-color]="item.backgroundColor" [style.color]="item.textColor"></span>
    </div>
  </div>
</ng-template>
